require('./field.less');

//TODO: this markup should be more semantic / accessible

var Marionette = require('marionette');

module.exports = Marionette.ItemView.extend({
    className: 'fieldWr',
    template: require('./field.hbs'),
    serializeData: function() {

        var m = this.model;

        return {
            fieldName: m.get('name'),
            fieldValue: m.getMultiLineDisplayValue()
        };

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/index/view/index/field.js
 ** module id = 576
 ** module chunks = 0
 **/